module.exports = __webpack_public_path__ + "img/mainnight.656408ed.png";